import { ulid } from "ulid"
import { ITrigger, ITriggerJavaData, ITriggerWebConfig, createTriggerUtils } from "@droid/project-v2-interface"
import { scriptTriggerNamespace } from "../script-namespace"
import { UI } from "./UI"
import { Log } from "@fanfanlo"

const fileLog = new Log(false, '[ITriggerScript]')
fileLog.pause = true
fileLog.childrenPaused = true

const type = `${scriptTriggerNamespace}script`
fileLog.log('[ITriggerScript] type:', type)

export interface ITriggerScriptJavaData extends ITriggerJavaData {
    script: string
    scriptMode: 'simple' | 'advanced' | 'full'
}

export interface ITriggerScriptWebConfig extends ITriggerWebConfig {
    // Script Trigger 特有的 Web 配置
}

export interface ITriggerScriptData extends ITrigger<ITriggerScriptJavaData, ITriggerScriptWebConfig> {
    javaData: ITriggerScriptJavaData
}

function createDefaultData(): ITriggerScriptData {
    fileLog.log('[ITriggerScript.createDefaultData] 开始创建默认数据')

    const ulidValue = ulid()
    fileLog.log('[ITriggerScript.createDefaultData] 生成ulid:', ulidValue)

    const defaultData: ITriggerScriptData = {
        
        ulid: ulidValue,
        uuid: '',
        ownerUuid: '',
        currentVersion: 0,
        type,
        name: 'triggerScript',
        javaData: {
            script: '',
            scriptMode: 'simple'
        },
        createdAt: 0,
        updatedAt: 0,
        authorUuid: '',
    }
    fileLog.log('[ITriggerScript.createDefaultData] defaultData:', JSON.stringify(defaultData))
    return defaultData
}

function init() {
    fileLog.log('[ITriggerScript.init] 初始化')
}

export const triggerScriptUtils = createTriggerUtils(type, init, createDefaultData, UI)
